const SVGFacebook = () => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    {/* <title>Check us out on Facebook</title> */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.688477 15.9998C0.688477 7.26245 7.77336 0.179443 16.513 0.179443C25.2527 0.179443 32.3375 7.26245 32.3375 15.9998C32.3375 24.7371 25.2527 31.8201 16.513 31.8201C7.77336 31.8201 0.688477 24.7371 0.688477 15.9998Z"
      fill="#535360"
    />
    <g clipPath="url(#clip0_1009_2562)">
      <path
        d="M17.8161 18.3067H20.1807L21.1265 14.5234H17.8161V12.6317C17.8161 11.6575 17.8161 10.7401 19.7078 10.7401H21.1265V7.5621C20.8182 7.52143 19.6538 7.42969 18.4243 7.42969C15.8563 7.42969 14.0328 8.99692 14.0328 11.8751V14.5234H11.1953V18.3067H14.0328V26.3462H17.8161V18.3067Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1009_2562">
        <rect
          width="22.7001"
          height="22.7001"
          fill="white"
          transform="translate(4.57422 3.64624)"
        />
      </clipPath>
    </defs>
  </svg>
);

// eslint-disable-next-line import/no-default-export
export default SVGFacebook;
